import React from 'react'
import {Lang} from 'yougile-lang'
import {DataObjectId, Hub} from 'yougile-model'
import {Sync} from '@client/sync'
import {OptionsItem} from '@components/common/base/dropdown-button-menu/types'
import {SelectWithDropdown} from '@components/common/base/select-with-dropdown'
import {useForceUpdate, useSyncEvent} from '@containers/hooks'
import {Board} from '@extensions/board'

export const DealColumnSelector = ({deal}: {deal: Hub}) => {
  const box = Sync.get(deal)
  const column = box.getHub(deal.location)
  if (!column) {
    return null
  }
  const board = box.getHub(column.location)
  if (!board) {
    return null
  }

  const forceUpdate = useForceUpdate()

  useSyncEvent(
    'current',
    {filter: board.id, debounceTime: 50},
    () => {
      forceUpdate()
    },
    [board]
  )

  const allColumns = Board.listColumns(board, {sorted: true, noMirrors: true})

  const options: OptionsItem<DataObjectId>[] = allColumns.map(col => ({
    key: col.id,
    text: col.title
  }))

  const onChange = (opt: OptionsItem<DataObjectId>) => {
    const targetCol = box.getHub(opt.key)

    if (targetCol) {
      box.moveTreeNode(deal, deal.location, targetCol.id, true, false)
    }
  }

  const selectedOption = options.find(opt => opt.key === column.id)

  return (
    <SelectWithDropdown
      options={options}
      value={selectedOption?.text}
      onChange={onChange}
      size="32"
      width="w-full"
      placeholder={Lang.msg.crm.rightPanel.dealStatus}
      variant="new"
    />
  )
}
